import React from 'react';
import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0.4;
  }
  100% {
    transform: translateY(-100vh) rotate(360deg);
    opacity: 0;
  }
`;

const FloatingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  overflow: hidden;
`;

const FloatingElement = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 2;
  animation: ${float} ${props => props.duration}s linear infinite;
  left: ${props => props.left}%;
  top: 0;
  font-size: ${props => props.size}px;
  color: ${props => props.color};
  opacity: 0.4;
  text-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
  will-change: transform;
`;

const Bubble = styled(FloatingElement)`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  will-change: transform;
`;

const FloatingEffects = () => {
  const elements = [];

  // 添加爱心
  for (let i = 0; i < 15; i++) {
    elements.push({
      type: 'heart',
      left: Math.random() * 100,
      duration: 8 + Math.random() * 7,
      size: 35 + Math.random() * 25,
      color: `rgba(${255}, ${Math.floor(Math.random() * 100)}, ${Math.floor(Math.random() * 100)}, 0.4)`,
    });
  }

  // 添加泡泡
  for (let i = 0; i < 10; i++) {
    elements.push({
      type: 'bubble',
      left: Math.random() * 100,
      duration: 10 + Math.random() * 5,
      size: 30 + Math.random() * 30,
    });
  }

  return (
    <FloatingContainer>
      {elements.map((element, index) => (
        element.type === 'heart' ? (
          <FloatingElement
            key={index}
            left={element.left}
            duration={element.duration}
            size={element.size}
            color={element.color}
            style={{
              position: 'fixed',
              pointerEvents: 'none',
              zIndex: 2,
              animation: `float ${element.duration}s linear infinite`,
              left: `${element.left}%`,
              top: 0,
              fontSize: `${element.size}px`,
              color: element.color,
              opacity: 0.4,
              textShadow: '0 0 15px rgba(255, 255, 255, 0.3)',
              willChange: 'transform'
            }}
          >
            ❤
          </FloatingElement>
        ) : (
          <Bubble
            key={index}
            left={element.left}
            duration={element.duration}
            size={element.size}
            style={{
              position: 'fixed',
              pointerEvents: 'none',
              zIndex: 2,
              animation: `float ${element.duration}s linear infinite`,
              left: `${element.left}%`,
              top: 0,
              width: `${element.size}px`,
              height: `${element.size}px`,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(2px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              willChange: 'transform'
            }}
          />
        )
      ))}
    </FloatingContainer>
  );
};

export default FloatingEffects; 